export const TitleBar = {
    title: "Danh sách mua hàng",
    addButtonText: "Tạo đơn mua hàng",
};

export const CreateMaterialOrderTitleBar = {
    title: "Tạo mới đơn hàng vật tư",
    addButtonText: "Tạo mới yêu cầu vật tư",
};

export const Search = {
    searchText: "Tìm kiếm theo từ khoá Mã yêu cầu, Nhà cung cấp",
};

export const Filter = {
    filterText: "Bộ lọc",
    filterTitle: "Lựa chọn và áp dụng bộ lọc để hiển thị thông tin tìm kiếm",
};

export const Sort = {
    sortText: "Sắp xếp:",
    sortButtonText: "Ngày đến hạn gần nhất",
};

export interface ColumnAttribute {
    text: string;
    icon: any;
}

export const TableColumns = [
    { text: "Mã yêu cầu", icon: <></> },
    { text: "Nhà cung cấp", icon: <></> },
    { text: "Trạng thái", icon: <></> },
    { text: "Ngày đến hàng", icon: <></> },
    { text: "Giá", icon: <></> },
    // { text: "Phụ trách", icon: <></> },
];

export const PaginationBarConfig = {
    text: "Hiển thị",
    page: "Trong",
};

export const MaterialOrderMaterialTableColumns = [
    { text: "Mã vật tư", icon: <></> },
    { text: "Tên vật tư", icon: <></> },
    { text: "Giá", icon: <></> },
    { text: "Số lượng", icon: <></> },
    { text: "", icon: <></> },
];

export const MaterialOrderAddMaterialTableColumns = [
    { text: "Mã vật tư", icon: <></> },
    { text: "Tên vật tư", icon: <></> },
    { text: "Giá", icon: <></> },
    { text: "Tồn kho", icon: <></> },
    { text: "Số lượng", icon: <></> },
    { text: "", icon: <></> },
];

export const WarningCancelMaterialOrder = {
    title: "Huỷ đơn hàng",
    context: [
        "Huỷ đơn hàng sẽ tạm dừng tất cả các hoạt động liên quan, bạn có chắc muốn huỷ bỏ không? " +
            "Hành động này sẽ không được hoàn tác.",
    ],
    reason: "Lý do hủy đơn hàng",
};

export const WarningDiscardMaterialProductOrder = {
    title: "Huỷ tạo đơn hàng",
    context:
        "Thông tin bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn " +
        "muốn huỷ bỏ không? Hành động này sẽ không được hoàn tác.",
};

export const WarningDeclineMaterialOrder = {
    title: "Từ chối duyệt đơn hàng",
    context: ["Bạn có chắc chắn muốn từ chối duyệt đơn hàng này không? Hành động này sẽ không được hoàn tác"],
    reason: "Lý do từ chối",
};

export const WarningDeclineReasonMaterialOrder = {
    title: "Lý do đơn hàng vật tư bị từ chối",
};
